import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl ,link}) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div onClick={()=> window.open(link)} className="proj-imgbx cpp">
        <img src={imgUrl} alt="img"/>
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
      </div>
    </Col>
  )
}
